import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import get from 'lodash/get';
import { Button } from '@lightspeed/flame/Button';
import Group from '@lightspeed/cirrus-group';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/cirrus-modal';

import EditForm from './Form';
import validationSchema from './Form/validations';

export const ERROR_CODES = {
  VALIDATION_ERROR: 'validation_error',
};

export const ERROR_MESSAGE = {
  VALIDATION_ERROR: 'The name may not be greater than 50 characters.',
};

export class EditCCTerminalComponent extends Component {
  componentDidUpdate(prevProps) {
    const { isOpen, ccTerminalErrors, resetForm, setFieldError } = this.props;

    if (prevProps.isOpen !== isOpen) {
      resetForm();
    }

    if (prevProps.ccTerminalErrors !== ccTerminalErrors) {
      ccTerminalErrors.forEach(apiError => {
        const errorCode = get(apiError, 'response.data.errorCode', '');

        if (errorCode === ERROR_CODES.VALIDATION_ERROR) {
          setFieldError('name', ERROR_MESSAGE.VALIDATION_ERROR);
        }
      });
    }
  }

  render() {
    const {
      errors,
      handleBlur,
      handleChange,
      handleSubmit,
      isOpen,
      isProcessing,
      isValid,
      onCancel,
      touched,
      values,
    } = this.props;

    return (
      <Modal
        className="cirrus"
        closeOnEsc={!isProcessing}
        isOpen={isOpen}
        onRequestClose={onCancel}
        shouldCloseOnOverlayClick={!isProcessing}
      >
        <ModalHeader showCloseButton={false}>Edit a Payment Terminal</ModalHeader>
        <form onSubmit={handleSubmit}>
          <ModalBody>
            <div style={{ width: '400px' }}>
              <EditForm
                errors={errors}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched}
                values={values}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Group className="cr-justify-end">
              <Button
                onClick={onCancel}
                disabled={isProcessing}
                data-test="retail-payments-ccterminal-cancel"
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                disabled={!isValid}
                data-test="retail-payments-ccterminal-save"
                fill
                loading={isProcessing}
                type="submit"
              >
                Save
              </Button>
            </Group>
          </ModalFooter>
        </form>
      </Modal>
    );
  }
}

const formSettings = {
  enableReinitialize: true,
  mapPropsToValues: ({ ccTerminal = { name: '' } }) => ({
    name: ccTerminal.name,
  }),
  handleSubmit(values, actions) {
    const mappedPayload = { ...actions.props.ccTerminal, name: values.name.trim() };
    actions.props.onSuccess(mappedPayload);
  },
  validationSchema,
};

EditCCTerminalComponent.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  isProcessing: PropTypes.bool,
};

export default withFormik(formSettings)(EditCCTerminalComponent);
